import Api from '../Base'

class GetPromoMechanics extends Api {
  requestUrl = `/api/PromoMechanic`
}

export default GetPromoMechanics
